export const ACTION_TYPES = {
    ADD_TAB:"ADD_TAB",
    REMOVE_TAB:"REMOVE_TAB",
    TERMINAL_TOGGLE:"TERMINAL_TOGGLE",
    ADMIN_LOGIN:"ADMIN_LOGIN",
    ADMIN_LOGOUT:"ADMIN_LOGOUT",
}